/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function InfoFilledIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "info-filled", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 12.5C21 17.1944 17.1944 21 12.5 21C7.80558 21 4 17.1944 4 12.5C4 7.80558 7.80558 4 12.5 4C17.1944 4 21 7.80558 21 12.5ZM12 10.5V9H13V10.5H12ZM13 16V12H12V16H13Z", fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(InfoFilledIcon);
export default ForwardRef;
//# sourceMappingURL=infoFilledIcon.js.map